import { render, staticRenderFns } from "./StudentGroupTransfer.vue?vue&type=template&id=2a4a6c58&scoped=true"
import script from "./StudentGroupTransfer.vue?vue&type=script&lang=js"
export * from "./StudentGroupTransfer.vue?vue&type=script&lang=js"
import style0 from "./StudentGroupTransfer.vue?vue&type=style&index=0&id=2a4a6c58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a6c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4a6c58')) {
      api.createRecord('2a4a6c58', component.options)
    } else {
      api.reload('2a4a6c58', component.options)
    }
    module.hot.accept("./StudentGroupTransfer.vue?vue&type=template&id=2a4a6c58&scoped=true", function () {
      api.rerender('2a4a6c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/StudentGroupTransfer.vue"
export default component.exports